import { API_BASE_URL} from "../baseURL";
import Select from '@mui/material/Select';
import MenuItem from "@mui/material/MenuItem";
import { useEffect, useState } from "react";

const EditFarmerModal = ({ farmer, setFarmers, setShowEditModal }) => {
    const [users, setUsers] = useState(null);
    const [name, setName] = useState(farmer.user);

    useEffect(() => {
        if (!users) {
            fetch(`${API_BASE_URL}/users/salespersons`, {
                headers: {
                    "content-type": "application/json",
                    "Authorization": "Bearer " + localStorage.getItem('token')
                },
                method: "GET",
            })
                .then((response) => response.json())
                .then((data) => {
                    setUsers(data)
                    document.getElementById("hiddenUser").innerHTML = farmer.user;
                });
        }
    }, []);
    function save(farmerId) {
        fetch(`${API_BASE_URL}/farmers/update-farmer`, {
            method: "POST",
            headers: {
                "content-type": "application/json",
                "Authorization": "Bearer " + localStorage.getItem('token')
            },
            body: JSON.stringify(
                {
                        farmerId:   parseInt(farmerId),
                        firstName:  document.getElementById("firstname").innerHTML === '<br>' ? '' : document.getElementById("firstname").innerHTML,
                        surname:    document.getElementById("surname").innerHTML === '<br>' ? '' : document.getElementById("surname").innerHTML,
                        email:      document.getElementById("email").innerHTML === '<br>' ? '' : document.getElementById("email").innerHTML,
                        land:       document.getElementById("land").innerHTML === '<br>' ? '' : document.getElementById("land").innerHTML,
                        plz:        document.getElementById("plz").innerHTML === '<br>' ? '' : document.getElementById("plz").innerHTML,
                        location:   document.getElementById("location").innerHTML === '<br>' ? '' : document.getElementById("location").innerHTML,
                        address:    document.getElementById("address").innerHTML === '<br>' ? '' : document.getElementById("address").innerHTML,
                        festnetz:   document.getElementById("festnetz").innerHTML === '<br>' ? '' : document.getElementById("festnetz").innerHTML,
                        handy:      document.getElementById("handy").innerHTML === '<br>' ? '' : document.getElementById("handy").innerHTML,
                        user:       document.getElementById("hiddenUser").innerHTML === '<br>' ? '' : document.getElementById("hiddenUser").innerHTML,
                        comment:    document.getElementById("comment").innerHTML === '<br>' ? '' : document.getElementById("comment").innerHTML
                    }
                )
        }).then(response => response.json())
            .then(data => setFarmers(data))
    }

    const handleChange = event => {
        setName(event.target.value);
        document.getElementById("hiddenUser").innerHTML = event.target.value;
    };

    return (
        <>
            <div className="custom-modal">
                <div className="custom-modal-dialog">
                    <div>
                        <button onClick={() => setShowEditModal(false)} style={{float: "right"}}> &times; </button>
                        <h4>Landwirt: {farmer.surname}</h4>
                    </div>

                    <br/>

                    <input id="farmerId" value={farmer.id} hidden/>

                    <table id="editFarmerTable">
                        <tbody>
                            <tr>
                                <td style={{width: "20%"}}><b> Vorname </b></td>
                                <td><div contentEditable="true" id="firstname">{farmer.firstName}</div></td>
                            </tr>

                            <tr>
                                <td><b> Nachname </b></td>
                                <td><div contentEditable="true" id="surname">{farmer.surname}</div></td>
                            </tr>

                            <tr>
                                <td><b> E-mail </b></td>
                                <td><div contentEditable="true" id="email">{farmer.email}</div></td>
                            </tr>

                            <tr>
                                <td><b> Land </b></td>
                                <td><div contentEditable="true" id="land">{farmer.land}</div></td>
                            </tr>

                            <tr>
                                <td><b> PLZ </b></td>
                                <td><div contentEditable="true" id="plz">{farmer.plz}</div></td>
                            </tr>

                            <tr>
                                <td><b> Ort </b></td>
                                <td><div contentEditable="true" id="location">{farmer.location}</div></td>
                            </tr>

                            <tr>
                                <td><b> Adresse </b></td>
                                <td><div contentEditable="true" id="address">{farmer.address}</div></td>
                            </tr>

                            <tr>
                                <td><b> Festnetz</b></td>
                                <td><div contentEditable="true" id="festnetz">{farmer.festnetz}</div></td>
                            </tr>

                            <tr>
                                <td><b> Handynummer </b></td>
                                <td><div contentEditable="true" id="handy">{farmer.handy}</div></td>
                            </tr>

                            <tr>
                                <td><b> AD </b></td>
                                <td>
                                    <Select
                                        id="user"
                                        value={name}
                                        onChange={handleChange}
                                        variant="outlined">
                                            { users ?
                                                users.map((user) => {
                                                    return (
                                                        <MenuItem key={user.id} value={user.surname}>{user.surname}</MenuItem>
                                                    );
                                                }): null }
                                    </Select>
                                </td>
                            </tr>

                            <tr>
                                <td><b> Kommentar </b></td>
                                <td><div contentEditable="true" id="comment">{farmer.comment}</div></td>
                            </tr>

                            <tr style={{display: "none"}}>
                                <td><div contentEditable="true" id="hiddenUser"></div></td>
                            </tr>
                        </tbody>
                    </table>

                    <div style={{marginTop: "20px"}}>
                        <button onClick={() => { setShowEditModal(false) }} className="custom-btn-close"> Schließen </button>
                        <button
                            onClick={() => {
                                setShowEditModal(false)
                                save(document.getElementById("farmerId").value)
                                }
                            }
                            className="custom-btn-save"> Speichern </button>
                    </div>
                </div>
            </div>
        </>
    );
};

export default EditFarmerModal;
